export const sanitizeQuerySelector = (querySelector) => querySelector
  .replaceAll("?", "")
  .replaceAll("'", "")
  .replaceAll("&", "")
  .replaceAll("(", "")
  .replaceAll(")", "")
  .replaceAll(".", "")
  .replaceAll(",", "")
  .replaceAll("[", "")
  .replaceAll("]", "")